import { ContactFormSettingsKey } from "../../form-settings/form-experience/form-settings-keys.js";
import { createEnumFromKeys, type EnumFromKeys } from "@mcwd/typescript-type-guards";


type ContactForms = ContactFormSettingsKey;
const ContactForms = [ContactFormSettingsKey] as const;
type MessageTranslationKey<TName extends string> = `${TName}-message`;

type FormMapType = MessageTranslationKey<ContactForms>;
const FormsTypeMap = ContactFormSettingsKey.map(x => `${x}-message`) as FormMapType[];

export const ContactPostTextKeys = [
  ...FormsTypeMap,
  "pricing-thank-you",
  "pricing-rc-statement",
  "pricing-rc",
  "contact-phone-number",
  "contact-thank-you",
  "contact-href-value",
  "raise-your-hand",
  "event-registration-support-copy",
  "ppc-contact-heading"
] as const;

export type ContactFormPostKeys = (typeof ContactPostTextKeys)[number];

export type ContactFormPostKeysEnum = EnumFromKeys<ContactFormPostKeys, true>
export const ContactFormPostKeysEnum = createEnumFromKeys(ContactPostTextKeys, true);

//create the pattern for the phone number slot
type phoneNumberSlot = "phone-number-slot";
type TranslationWithPhoneNumberSlot<
  BeforeText extends string = string
> = `${BeforeText}{${phoneNumberSlot}}`;

type CustomContactSlot = {
  [ContactFormPostKeysEnum.contactMessage]: TranslationWithPhoneNumberSlot<string>;
};
type CustomContactSlotKey = keyof CustomContactSlot;
export type ConctactFormsPostTextFields = {
  readonly [Key in ContactFormPostKeys]: Key extends CustomContactSlotKey ? CustomContactSlot[Key] : string; 
};
